import { Pipe, PipeTransform } from '@angular/core';
import { DatetimeService } from 'app/services/datetime/datetime.service';


@Pipe({
  name: 'converterBRT',
  standalone: true
})
export class ConverterBRTPipe implements PipeTransform {

  constructor(private datetimeService: DatetimeService ){}

  transform(value: string): string {
    let horario: string = this.datetimeService.HorarioUTCparaBRT(value);
    return horario.substring(0, 5);
  }

}
